import { FC, memo } from 'react';
import { SkeletonWrapper, GroupWrapper } from './skeleton.styled';
import { Skeleton } from '../../components-v4';

export const AccrualsSkeleton: FC = memo(() => {
  return (
    <SkeletonWrapper>
      <Skeleton
        width={'120px'}
        height={'24px'}
        style={{ marginBottom: '16px' }}
      />
      <Skeleton
        width={'100%'}
        height={'40px'}
        style={{ marginBottom: '8px' }}
      />
      <GroupWrapper style={{ marginBottom: '8px' }}>
        <Skeleton width={'180px'} height={'24px'} />
        <Skeleton width={'100px'} height={'24px'} />
      </GroupWrapper>
      <GroupWrapper style={{ marginBottom: '16px' }}>
        <Skeleton width={'180px'} height={'24px'} />
        <Skeleton width={'100px'} height={'24px'} />
      </GroupWrapper>
      <Skeleton width={'100%'} height={'48px'} />
    </SkeletonWrapper>
  );
});
